import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { logger } from '@app/core/helpers/logger';
import { LoadingBarService } from '@core/components/spinners/loading-bar/loading-bar.service';
import { ClassroomParticipantsBlockType, ClassroomsService, IFindClassroomParticipantsFilter } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import {
  Classroom,
  ClassroomParticipant,
  ClassroomParticipantDetailsType,
  ClassroomParticipantRoleEnum,
} from 'lingo2-models';
import { takeUntil } from 'rxjs/operators';
import { IUserCard } from '../../classroom-user-card';
import {ErrorNotificationService} from "@shared/error-notification/error-notification.service";

const details: ClassroomParticipantDetailsType[] = ['id', 'user_id', 'accept_status', 'joined_at', 'user:sm'];

@Component({
  selector: 'app-classroom-participants',
  templateUrl: './classroom-participants.component.html',
  styleUrls: ['./classroom-participants.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassroomParticipantsComponent extends ChangableComponent implements OnInit {
  @Input()
  classroom: Classroom;

  public users: IUserCard[] = [];
  public inviteModal = false;
  public participants: ClassroomParticipantsBlockType = {
    items: [],
    loading: false,
    loaded: false,
    filter: {
      // public: true,
    },
    pagination: {
      page: 1,
      pageSize: 5,
      total: 0,
      totalPages: 0,
    },
  };

  constructor(
    public errorNotificationService: ErrorNotificationService,
    private classroomsService: ClassroomsService,
    private loadingBar: LoadingBarService,
    protected readonly cdr: ChangeDetectorRef,
  ) {
    super(cdr);
  }

  ngOnInit(): void {
    this.loadParticipants();
  }

  public trackByFn(index, user: IUserCard): string {
    return user.id;
  }

  public openInviteModal() {
    this.inviteModal = true;
  }

  public closeInviteModal() {
    this.inviteModal = false;
    this.loadParticipants();
  }

  protected loadParticipants(nextPage = false) {
    this.participants.loading = true;
    this.loadingBar.fetchingStart(35);
    if (nextPage && this.participants.pagination.page < this.participants.pagination.totalPages) {
      this.participants.pagination.page = this.participants.pagination.page + 1;
    }

    const filter: Partial<IFindClassroomParticipantsFilter> = {
      role: ClassroomParticipantRoleEnum.student,
    };
    this.classroomsService
      .getClassroomParticipants(this.classroom.id, this.participants.pagination, details, filter)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (response) => {
          if (nextPage) {
            response.results.map((t) => {
              if (!this.participants.items.find((t1) => t1.id === t.id)) {
                this.participants.items.push(t);
              }
            });
          } else {
            this.participants.items = response.results;
          }

          this.participants.pagination.total = response.total;
          this.participants.pagination.totalPages = response.totalPages;
          this.participants.pagination.page = response.page;
          this.participants.loaded = true;
          this.participants.loading = false;
          this.loadingBar.fetchingComplete();
          this.markForCheck();
        },
        error: (error: any) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
          this.participants.loading = false;
          this.loadingBar.fetchingStop();
          this.markForCheck();
        }
      });
  }

  public nextParticipantsPage() {
    this.loadParticipants(true);
  }

  // функция для трекинга списка, чтобы он не 'моргал'
  public trackParticipantByFn(index, item: ClassroomParticipant): string {
    return item.id;
  }
}
